import React from "react";
import "./Logo_holder.css";

function Logo_holder() {
  return (
    <>
      <div className="logo_holder">
        <img
          className="insurer_logo_img"
          src={
            process.env.PUBLIC_URL +
            "/assets/Image/Know_Your_Plan/icon/0_percent.png"
          }
          alt="insurer_logo_img"
        />
      </div>
    </>
  );
}

export default Logo_holder;
